/**
 * Returns display text for a specialty entity that has optional translations.
 * @param {Object} item - Entity (category, branch, attribute, item, title)
 * @param {string} locale - Language code (e.g. i18n.language)
 * @param {string} textKey - Key of the fallback text field (e.g. 'specialtyCategoryName', 'branchName')
 * @param {string} translateKey - Key of the translate object (e.g. 'translate')
 * @returns {string}
 */
export function getDisplayText(item, locale, textKey, translateKey = "translate") {
  const translations = item && item[translateKey] && typeof item[translateKey] === "object" ? item[translateKey] : null;
  if (translations && locale && translations[locale] != null && String(translations[locale]).trim() !== "") {
    return String(translations[locale]).trim();
  }
  const fallback = item && item[textKey];
  return fallback != null ? String(fallback) : "";
}
